// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MX4dt","fullView":"styles_fullView__3fAHq"};